import { MenuItem } from '@mui/material';
import { useRegion } from 'common/hooks/region';
import * as React from 'react';
import { useQuery } from '@tanstack/react-query';
import { fetchShippingLines, ShippingLineQueryKeys } from 'services/clients/shippingLine';
import { Selector } from 'components/Selectors';

interface Props {
  value: string;
  onChange: (value: string) => void;
}

export const ShippingLineSelector: React.FC<Props> = (props) => {
  const { value, onChange } = props;
  const region = useRegion();

  const shippingLines = useQuery(
    [ShippingLineQueryKeys.ShippingLines, region.code],
    ({ signal }) => fetchShippingLines({ signal, portCollectionCodes: [region.code] }),
    {
      onError: (e) => {
        // eslint-disable-next-line no-console
        console.error(e);
      },
    }
  );

  const items = React.useMemo(() => {
    if (!shippingLines.data) {
      return [];
    }

    return shippingLines.data.map((shippingLine) => {
      return (
        <MenuItem key={shippingLine.key} value={shippingLine.key}>
          {shippingLine.name}
        </MenuItem>
      );
    });
  }, [shippingLines.data]);

  return (
    <Selector
      id="shipping-line-selector"
      label="Shipping Line"
      value={shippingLines.data ? value || '' : ''}
      onChange={onChange}
      disabled={!shippingLines.isSuccess}
      loading={shippingLines.isLoading}
      placeholder="Select a shipping line"
      renderValue={(v) => shippingLines.data?.find((sl) => sl.key === v)?.name}
    >
      {items}
    </Selector>
  );
};
ShippingLineSelector.displayName = 'Selector.ShippingLine';
